import {
  container,
  defaultFont,
  minHeight,
  appbarHeight,
  drawerWidth
} from "./../psacount";

const headerStyle = {
  appBar: {
    ...defaultFont,
    // [theme.breakpoints.down('md')]: {
    // width: `calc(100% - ${drawerWidth}px)`
    // width: `calc(100%)`,
    // },
    // #546e7a
    position: "absolute",
    backgroundColor: "#546e7a !important",
    borderBottom: "0",
    marginBottom: "0",
    height: appbarHeight,
    paddingTop: "0px !important",
    zIndex: "100",
    border: "0",
    borderRadius: "0 !important",
    padding: "0 !important",
    transition: "all 150ms ease 0s",
    minHeight: minHeight,
    display: "inline",
    color: "#fff"
  },
  maintoolbar: {
    ...container,
    ...defaultFont,
    minHeight: minHeight,
    height: appbarHeight,
    width: "100%",

  },
  flex: {
    flex: 1
  },
  menuitem: {
    ...defaultFont,
    letterSpacing: "unset",
    lineHeight: appbarHeight,
    fontSize: "19px",
    borderRadius: "0",
    textTransform: "none",
    color: "#fff",
    margin: "0",
    "&:hover": {
      background: "#639DAA"
    },
    fontWeight: "700 !important"
    , cursor: "pointer"

  },
  text: {
    ...defaultFont,
    letterSpacing: "unset",
    lineHeight: appbarHeight,
    fontSize: "16px",
    borderRadius: "0",
    textTransform: "none",
    color: "#000",
    margin: "0",

    "&:hover": {
      background: "#639DAA"
    },
    fontWeight: "700 !important",
  },
  appResponsive: {
    top: "8px"
  },
  DrawerHeader: {
    backgroundColor: "#546e7a !important",
  },
  SwipeableDrawer: {
    backgroundColor: "#546e7a !important",
  }
}
export default headerStyle;